const API_URL = 'https://elitebet-api-production.up.railway.app/api';

export const api = {
  // Auth (Admin)
  login: (email, password) => 
    fetch(`${API_URL}/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password })
    }).then(r => r.json()),

  register: (email, password) => 
    fetch(`${API_URL}/auth/register`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password })
    }).then(r => r.json()),

  verifyToken: (token) =>
    fetch(`${API_URL}/auth/verify`, {
      headers: { 'Authorization': `Bearer ${token}` }
    }).then(r => r.json()),

  // Races
  getRaces: () => fetch(`${API_URL}/races`).then(r => r.json()),
  getCurrentRace: () => fetch(`${API_URL}/races/current`).then(r => r.json()),
  createRace: (data, token) =>
    fetch(`${API_URL}/races`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
      body: JSON.stringify(data)
    }).then(r => r.json()),
  endRace: (id, token) =>
    fetch(`${API_URL}/races/${id}/end`, {
      method: 'POST',
      headers: { 'Authorization': `Bearer ${token}` }
    }).then(r => r.json()),

  // Players
  getLeaderboard: () => fetch(`${API_URL}/players/leaderboard`).then(r => r.json()),
  getPreviousLeaderboard: () => fetch(`${API_URL}/players/leaderboard/previous`).then(r => r.json()),
  getPlayers: () => fetch(`${API_URL}/players`).then(r => r.json()),
  addPlayer: (data, token) =>
    fetch(`${API_URL}/players`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
      body: JSON.stringify(data)
    }).then(r => r.json()),
  updatePlayer: (id, data, token) =>
    fetch(`${API_URL}/players/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
      body: JSON.stringify(data)
    }).then(r => r.json()),
  payPlayer: (id, token) =>
    fetch(`${API_URL}/players/${id}/pay`, {
      method: 'POST',
      headers: { 'Authorization': `Bearer ${token}` }
    }).then(r => r.json()),
  deletePlayer: (id, token) =>
    fetch(`${API_URL}/players/${id}`, {
      method: 'DELETE',
      headers: { 'Authorization': `Bearer ${token}` }
    }).then(r => r.json()),
  bulkImportPlayers: (raceId, players, token) =>
    fetch(`${API_URL}/players/bulk`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
      body: JSON.stringify({ race_id: raceId, players })
    }).then(r => r.json()),

  // Settings
  getSettings: () => fetch(`${API_URL}/settings`).then(r => r.json()),
  getPrizes: () => fetch(`${API_URL}/settings/prizes`).then(r => r.json()),
  updateSetting: (key, value, token) =>
    fetch(`${API_URL}/settings/${key}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
      body: JSON.stringify({ value })
    }).then(r => r.json()),
  updatePrizes: (prizes, token) =>
    fetch(`${API_URL}/settings/prizes/bulk`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
      body: JSON.stringify({ prizes })
    }).then(r => r.json()),

  // Users (Admin)
  getUsers: (token) =>
    fetch(`${API_URL}/users`, {
      headers: { 'Authorization': `Bearer ${token}` }
    }).then(r => r.json()),
  
  searchUsers: (query, token) =>
    fetch(`${API_URL}/users/search/${query}`, {
      headers: { 'Authorization': `Bearer ${token}` }
    }).then(r => r.json()),
  
  creditUser: (userId, amount, reason, token) =>
    fetch(`${API_URL}/users/${userId}/credit`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
      body: JSON.stringify({ amount, reason })
    }).then(r => r.json()),
  
  debitUser: (userId, amount, reason, token) =>
    fetch(`${API_URL}/users/${userId}/debit`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
      body: JSON.stringify({ amount, reason })
    }).then(r => r.json()),
  
  getUserTransactions: (userId, token) =>
    fetch(`${API_URL}/users/${userId}/transactions`, {
      headers: { 'Authorization': `Bearer ${token}` }
    }).then(r => r.json()),
};

export default api;
